// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"567":"100883e8","608":"fe4a395e","616":"74a4c4fd"}[chunkId] + ".chunk.js";
};